import styled from 'styled-components';
import { Col, Badge } from 'antd';
import { Row } from './styledComponent';
import { WelcomeMessage } from './WelcomeMessage';
import profile from 'assets/images/home/Profile-filled.svg';
import notification from 'assets/images/home/notifications.svg';
import './style.less';
import { useEffect, useState } from 'react';
import { useLifeInboxMessageCount } from 'all-in-one-shared-api';
import { useKeycloak } from 'all-in-one-react-keycloak';
type GreetingSectionProps = {
  pageName?: string;
  showicon?: boolean;
  timesp?: string | number;
  count?: number;
};
// const ImageBlock = styled.img`
//   display: inline-block;
//   float: right;
// `;
const NavbArall = styled.div`
  margin: 0;
`;
const GreetingSection = (props: GreetingSectionProps) => {
  const [counts, setCounts] = useState(0);
  const { keycloak } = useKeycloak();
  const { timesp } = props;

  const [randoms, setRandoms] = useState(Math.random());
  const { shouldFetch, data, error } = useLifeInboxMessageCount(
    'useLifeInboxMessageCount' + randoms,
    keycloak.token as string,
  );
  /* eslint-disable */
  useEffect(() => {
    setCounts(props.count || 0);
  }, [props.count]);
  useEffect(() => {
    setRandoms(Math.random());
    shouldFetch(true);
  }, [keycloak.token]);
  useEffect(() => {
    if (!timesp) {
      setRandoms(Math.random());
    } else {
      setRandoms(timesp as number);
    }
    shouldFetch(true);
  }, []);

  useEffect(() => {
    setRandoms(timesp as number);
    shouldFetch(true);
  }, [timesp]);
  useEffect(() => {
    if (data) {
      setCounts(parseInt(data.count));
    }
  }, [data, error]);
  /* eslint-enable */

  return (
    <NavbArall className="NavbarAll">
      <Row align="middle" justify="space-between" style={{ background: '#c21b17', height: '88px' }} className="navRow">
        <WelcomeMessage showicon={props.showicon} pageName={props.pageName} />
        {props.showicon && (
          <Col
            span={6}
            style={{
              marginRight: '10px',
            }}
          >
            <Row justify="end">
              <Col sm={10} md={4} lg={4}>
                <a href="/LifeAccount">
                  <img
                    src={profile}
                    alt=""
                    style={{
                      marginRight: '20px',
                    }}
                  />
                </a>
              </Col>
              {counts > 0 && (
                <Col sm={{ span: 10, offset: 2 }} md={{ span: 4, offset: 0 }} lg={{ span: 4, offset: 0 }}>
                  <a href="/LifeInbox">
                    <Badge count={counts}>
                      <img src={notification} alt="" />
                    </Badge>
                  </a>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
    </NavbArall>
  );
};

export default GreetingSection;
